/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Launcher_CtaInputs */

const en_fc_dl_launcher_cta = /** @type {(inputs: Fc_Dl_Launcher_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the launcher`)
};

/**
* | output |
* | --- |
* | "Get the launcher" |
*
* @param {Fc_Dl_Launcher_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_launcher_cta = /** @type {((inputs?: Fc_Dl_Launcher_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Launcher_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_launcher_cta(inputs)
});
export { fc_dl_launcher_cta as "fc.dl.launcher.cta" }